import React from 'react'
import Error500Boundary from 'tennders-stracture/layouts/views/error/Error500Boundary'
import useComponent from 'tennders-common/hooks/useComponent'
import GeneralLayoutHeader from 'tennders-stracture/layouts/views/GeneralLayoutHeader'
import GeneralLayoutOuterTop from 'tennders-stracture/layouts/views/GeneralLayoutOuterTop'
import GeneralLayoutLoading from 'tennders-stracture/layouts/views/GeneralLayoutLoading'
import GeneralLayoutUserMenu from 'tennders-stracture/layouts/views/GeneralLayoutUserMenu'
import LayoutModals from 'tennders-stracture/layouts/views/LayoutModals'
import GeneralLayoutMeta from 'tennders-stracture/layouts/views/GeneralLayoutMeta'
import Script from 'next/script'
import QuickSearch from 'tennders-quick-search/QuickSearch'
import AuthBoundary from 'tennders-stracture/layouts/views/auth/AuthBoundary'
import useUserGuiding from '@/plugins/guiding/useUserGuiding'

const GeneralLayout = ({ children }) => {
  const guiding = useUserGuiding()

  const header = useComponent(
    children,
    {
      Component: GeneralLayoutHeader,
      displayName: GeneralLayoutHeader.displayName
    }
  )

  const meta = useComponent(
    children,
    {
      Component: GeneralLayoutMeta,
      displayName: GeneralLayoutMeta.displayName
    }
  )

  const outerTop = useComponent(
    children,
    {
      Component: GeneralLayoutOuterTop,
      displayName: GeneralLayoutOuterTop.displayName
    }
  )

  const userMenu = useComponent(
    children,
    {
      Component: GeneralLayoutUserMenu,
      displayName: GeneralLayoutUserMenu.displayName
    }
  )

  const loading = useComponent(
    children,
    {
      Component: GeneralLayoutLoading,
      displayName: GeneralLayoutLoading.displayName
    }
  )

  return (
    <AuthBoundary>
      <Error500Boundary>
        { guiding ? <Script async dangerouslySetInnerHTML={guiding} /> : null }
        {header}
        {meta}
        {outerTop}
        {userMenu}
        {loading}
        <LayoutModals />
        <QuickSearch />
      </Error500Boundary>
    </AuthBoundary>
  )
}

export default GeneralLayout
